<template>
  <div class="min-h-screen bg-gray-50 pt-20">
    <div class="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <h1 class="text-3xl font-bold text-gray-900 mb-4">Quem Somos</h1>

      <p class="text-gray-700 leading-relaxed mb-4">
        A <span class="font-semibold">TripDay</span> é uma plataforma para <span class="font-semibold">gerenciamento e divulgação de imóveis para temporada</span>.
        Nosso objetivo é conectar pessoas que buscam lugares para se hospedar com anfitriões que disponibilizam seus imóveis para locação.
      </p>

      <p class="text-gray-700 leading-relaxed mb-4">
        Qualquer pessoa pode usar a nossa vitrine pública para <span class="font-semibold">localizar imóveis para temporada</span>,
        visualizar fotos, detalhes e <span class="font-semibold">consultar a disponibilidade</span> em um calendário simples e visual.
        Ao encontrar um imóvel interessante, o usuário pode entrar em contato diretamente com o anfitrião via WhatsApp – a TripDay não realiza intermediação de pagamento nem reserva online.
      </p>

      <p class="text-gray-700 leading-relaxed mb-4">
        Diferente de outras plataformas, a <span class="font-semibold">TripDay não cobra comissões sobre reservas</span>,
        permitindo que anfitriões e hóspedes negociem diretamente e fujam das taxas cobradas por soluções tradicionais como Airbnb ou Booking.
      </p>

      <p class="text-gray-700 leading-relaxed mb-4">
        Neste momento, a TripDay é <span class="font-semibold">100% gratuita</span>. Se a plataforma bombar e evoluir, no futuro poderemos
        cobrar uma contribuição dos anfitriões pelo uso da TripDay. Vamos comunicar tudo com transparência antes de qualquer cobrança.
      </p>

      <p class="text-gray-700 leading-relaxed mb-4">
        Para <span class="font-semibold">os anfitriões e imobiliárias</span>, oferecemos uma plataforma completa para facilitar o gerenciamento das locações:
      </p>

      <ul class="list-disc list-inside text-gray-700 space-y-1 mb-4">
        <li>Cadastro e organização de imóveis para temporada.</li>
        <li>Gestão de pessoas (hóspedes, prestadores de serviço e corretores).</li>
        <li>Confirmação de reservas e acompanhamento do calendário de hospedagens.</li>
        <li>Emissão de contratos de locação</li>
        <li>Registro de despesas extras vinculadas a cada imóvel</li>
        <li>Dashboard com indicadores e análises das locações.</li>
        <li>Consulta rápida de disponibilidade por imóvel e período.</li>
      </ul>

      <p class="text-gray-700 leading-relaxed mb-6">
        <span class="font-semibold">Nosso foco</span> é dar mais controle e clareza para quem administra imóveis de temporada,
        mantendo uma experiência simples tanto para o anfitrião quanto para o hóspede.
      </p>

      <div class="border-t border-gray-200 pt-4 mt-4">
        <p class="text-gray-700">
          <span class="font-semibold text-2xl">Somos a TripDay</span><br />
          Plataforma para gestão e divulgação de imóveis de temporada.
        </p>
        <span class="text-sm text-gray-600">contato@tripday.com.br</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'About'
}
</script>

